import React from 'react';
import { theme } from 'codeArt/components/Base';
import { DataContext } from './context';
import { DeviceType } from 'app/constant';
import { getRandom } from 'app/components/common';
import { Util } from 'codeArt/common';



//在当前页面的路由表页面进行调用 否则不进行触发调用
export function importData() {
    DataContext.register([
        {
            name: "SCRAP_RATE",
            data: SCRAP_RATE
        },
        {
            name: "SCRAP_TOP5",
            data: ({ arg, dp }) => {
                let data = getDeviceData(arg.type);
                data = data.map((item) => {
                    item.forEach((t) => {
                        t.value = parseInt(parseFloat(t.value) * 100 * 2.5);
                        t.type = t.name;
                    });

                    item = Util.order(item, (t) => t.value)
                    item = item.slice(0, 5);
                    return item;
                })

                return data;
            }
        },
        {
            name: "SCRAP_EXCLUDING_COUNT",
            data: ({ arg }) => {
                let data = getDeviceData(arg.type);
                data = data.map((item) => {
                    item.forEach((t) => {
                        t.value = parseInt(parseFloat(t.value) * 1000);
                        t.type = t.name;
                    });
                    return item;
                })
                return data;
            }
        },
        {
            name: "SCRAP_EXCLUDING_RATE",
            data: ({ arg, dp }) => {
                let data = Util.clone(dp.history("SCRAP_EXCLUDING_COUNT"));
                data.forEach((t) => {
                    t.format = (value, percent) => { return percent };
                })
                return [data];
            }
        },
        {
            name: "SCRAP_REASON_PERCENTAGE",
            data: ({ arg }) => {
                if (!arg) return null;

                let data = [];
                switch (arg.type) {
                    case DeviceType.beads:
                        data = beadsData;
                        break;
                    case DeviceType.white:
                        data = whiteData;
                        break;
                    case DeviceType.hollow:
                        data = hollowData;
                        break;
                    case DeviceType.duality:
                        data = cmData;
                        break;
                    case DeviceType.ternary:
                        data = cmData;
                        break;
                }

                return Util.clone(data);
            }
        }
    ]);
}

const SCRAP_RATE = [
    [0.10, 0.05, 0.08, 0.12],
    [0.06, 0.09, 0.12, 0.08],
    [0.08, 0.12, 0.10, 0.06],
];

export function getDeviceData(type) {
    if (type == null) return null;

    let data = [];

    switch (type) {
        case DeviceType.beads:
            data = beadsData;
            break;
        case DeviceType.white:
            data = whiteData;
            break;
        case DeviceType.hollow:
            data = hollowData;
            break;
        case DeviceType.duality:
            data = cmData;
            break;
        case DeviceType.ternary:
            data = cmData;
            break;
    }

    return Util.clone(data);
}

export const ScrapType = {
    video: 1, //影像剔除
    other: 2 //其他剔除
}

const beadsData = [[
    // 神龙珠检测1 (爆珠棒)
    { name: "启停", value: "0.17", color: theme.color.danger, type: ScrapType.other },
    { name: "甘油", value: "0.12", color: theme.color.warning, type: ScrapType.other },
    { name: "圆周", value: "0.06", color: theme.color.pink, type: ScrapType.other },
    { name: "接纸", value: "0.14", color: theme.color['m-primary'], type: ScrapType.other },
    { name: "少珠", value: "0.16", color: theme.color.info, type: ScrapType.video },
    { name: "多珠", value: "0.04", color: theme.color.secondaryDark, type: ScrapType.video },
    { name: "相位", value: "0.15", color: theme.color['r-green'], type: ScrapType.video },
    { name: "色差", value: "0.05", color: theme.color['r-orange'], type: ScrapType.video },
    { name: "接头", value: "0.03", color: theme.color['light-blue'], type: ScrapType.video },
    { name: "破损", value: "0.08", color: theme.color['grey-system'], type: ScrapType.video }
],
[
    // 神龙珠检测2 (爆珠棒)
    { name: "启停", value: "0.13", color: theme.color.danger, type: ScrapType.other },
    { name: "甘油", value: "0.07", color: theme.color.warning, type: ScrapType.other },
    { name: "圆周", value: "0.12", color: theme.color.pink, type: ScrapType.other },
    { name: "接纸", value: "0.08", color: theme.color['m-primary'], type: ScrapType.other },
    { name: "少珠", value: "0.03", color: theme.color.info, type: ScrapType.video },
    { name: "多珠", value: "0.17", color: theme.color.secondaryDark, type: ScrapType.video },
    { name: "相位", value: "0.06", color: theme.color['r-green'], type: ScrapType.video },
    { name: "色差", value: "0.14", color: theme.color['r-orange'], type: ScrapType.video },
    { name: "接头", value: "0.09", color: theme.color['light-blue'], type: ScrapType.video },
    { name: "破损", value: "0.11", color: theme.color['grey-system'], type: ScrapType.video }
]];

const whiteData = [[
    // 高透棒检测1
    { name: "启停", value: "0.23", color: theme.color.danger, type: ScrapType.other },
    { name: "甘油", value: "0.33", color: theme.color.warning, type: ScrapType.other },
    { name: "圆周", value: "0.12", color: theme.color.pink, type: ScrapType.other },
    { name: "接纸", value: "0.32", color: theme.color['m-primary'], type: ScrapType.other }
],
[
    // 高透棒检测2
    { name: "启停", value: "0.08", color: theme.color.danger, type: ScrapType.other },
    { name: "甘油", value: "0.17", color: theme.color.warning, type: ScrapType.other },
    { name: "圆周", value: "0.42", color: theme.color.pink, type: ScrapType.other },
    { name: "接纸", value: "0.33", color: theme.color['m-primary'], type: ScrapType.other }
]];

const hollowData = [[
    // 中空棒检测1
    { name: "启停", value: "0.28", color: theme.color.danger, type: ScrapType.other },
    { name: "甘油", value: "0.12", color: theme.color.warning, type: ScrapType.other },
    { name: "圆周", value: "0.33", color: theme.color.pink, type: ScrapType.other },
    { name: "接纸", value: "0.27", color: theme.color['m-primary'], type: ScrapType.other }
],
[
    // 中空棒检测2
    { name: "启停", value: "0.16", color: theme.color.danger, type: ScrapType.other },
    { name: "甘油", value: "0.19", color: theme.color.warning, type: ScrapType.other },
    { name: "圆周", value: "0.32", color: theme.color.pink, type: ScrapType.other },
    { name: "接纸", value: "0.33", color: theme.color['m-primary'], type: ScrapType.other }
]];

const cmData = [[
    // 复合棒检测1
    { name: "启停", value: "0.09", color: theme.color.danger, type: ScrapType.other },
    { name: "圆周", value: "0.19", color: theme.color.pink, type: ScrapType.other },
    { name: "接纸", value: "0.10", color: theme.color['m-primary'], type: ScrapType.other },
    { name: "相位", value: "0.18", color: theme.color['r-green'], type: ScrapType.video },
    { name: "跳棒", value: "0.06", color: theme.color.info, type: ScrapType.other },
    { name: "接头", value: "0.22", color: theme.color['light-blue'], type: ScrapType.video },
    { name: "缝隙", value: "0.16", color: theme.color.warning, type: ScrapType.other }
],
[
    // 复合棒检测2
    { name: "启停", value: "0.16", color: theme.color.danger, type: ScrapType.other },
    { name: "圆周", value: "0.15", color: theme.color.pink, type: ScrapType.other },
    { name: "接纸", value: "0.13", color: theme.color['m-primary'], type: ScrapType.other },
    { name: "相位", value: "0.09", color: theme.color['r-green'], type: ScrapType.video },
    { name: "跳棒", value: "0.19", color: theme.color.info, type: ScrapType.other },
    { name: "接头", value: "0.22", color: theme.color['light-blue'], type: ScrapType.video },
    { name: "缝隙", value: "0.06", color: theme.color.warning, type: ScrapType.other }
]];

export const getExcludingData = (type) => {

    let datas = getDeviceData(type);

    if (!datas || datas.length == 0) return null;

    let all = getRandom(4000, 5000);

    let index = getRandom(0, 1);
    let data = datas[index];

    let result = [];
    data.map((t) => {
        let reason = t.name;
        let total = parseInt((parseFloat(t.value) * 1000 / all) * 10000) / 100 + "%";
        let excluding = parseInt(parseFloat(t.value) * 100) + "%";

        result.push({ reason, total, excluding });
    });

    return result;
};

export function getTotal(data) {
    let video = 0, other = 0;
    data.forEach((t) => {
        if (t.type == ScrapType.video) video = video + parseFloat(t.value);
        if (t.type == ScrapType.other) other = other + parseFloat(t.value);
    });

    let total = [{ name: "影像剔除", value: video.toFixed(2), color: theme.color.warning },
    { name: "其他剔除", value: other.toFixed(2), color: theme.color.green }];
    return total;
}

export function getDetail(data, type) {
    let info = data.filter((t) => { return t.type == type }) || [];

    if (info.length == 0) return [{ name: "影像剔除", value: "0", color: theme.color.warning }]

    return info;
}